<template>
  <!-- <div class="spinner">
    <img src="../assets/loading.svg" alt="loading"/>
  </div> -->
  <div class="blocco h100 w100">
    <circle4></circle4>
  </div>
</template>

<script>
  import {Circle4} from 'vue-loading-spinner'
  export default {
    name: 'callback',
    props: ['auth'],
    data () {
      this.auth.handleAuthentication(this.$route.query.id, this.$route.query.jwt, this.$route.query.profile)
      console.log(this.$route.query.id)
      return {}
    },
    components: {
      Circle4
    }
  }
</script>

<style>
  .spinner {
    position: absolute;
    display: flex;
    justify-content: center;
    height: 100vh;
    width: 100vw;
    background-color: white;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Callback.vue